import * as React from 'react';
import { useTranslation } from 'react-i18next';

import styles from '@/features/inspection-details/components/footer/footer.module.scss';
import { ReactComponent as deleteLogo } from '@/assets/icons/delete.svg';
import { SvgIcon } from '@mui/material';

export interface FooterProps {
    secondaryButton?: ActionButton;
    primaryButton?: ActionButton;
    extraButton?: ActionButton;
    previewButton?: ActionButton;
}

export interface ActionButton {
    label: string;
    styleName?: string;
    isDisabled?: boolean;
    onClick: () => void;
}
export const Footer: React.FC<FooterProps> = ({ secondaryButton, primaryButton, extraButton, previewButton }) => {
    const { t: translate } = useTranslation();

    return (
        <section className={styles.footer}>
            {secondaryButton && <button className={styles.back} onClick={secondaryButton.onClick} >{translate(secondaryButton.label)}</button>}
            {previewButton && <button className={styles.preview} onClick={previewButton.onClick} disabled={previewButton.isDisabled}>{translate(previewButton.label)}</button>}
            {primaryButton && <button disabled={primaryButton.isDisabled} className={primaryButton.styleName === 'submit' ? styles.submit : styles.next} onClick={primaryButton.onClick} >{translate(primaryButton.label)}</button>}
            {extraButton && <button className={styles.deleteButton} onClick={extraButton.onClick}  >
                <SvgIcon component={deleteLogo} sx={{ fill: 'none', height: '1.67rem' }} />
            </button>}
        </section>
    )
}